import(/* webpackMode: "eager" */ "/workspace/src/app/forgot-password/page.tsx");
